import React from 'react';
import impressumContent from '../data/impressumData';
import PageWrapper from "../components/PageWrapper";

const Impressum = () => {
  return (
    <PageWrapper>
      <div
        className="py-12 sm:py-16 min-h-screen"
        style={{
          backgroundImage: `url('/gradient_bg.svg'), linear-gradient(to bottom, #0ea5e9, #ffffff 50%, #ffffff)`,
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundSize: "cover, cover",
          backgroundPosition: "center, center",
        }}
      >
        <div className="mx-auto max-w-6xl lg:max-w-6xl px-6 sm:px-6 lg:px-4">
          <div className="grid grid-cols-1 lg:grid-cols-10 gap-8 items-start font-body">
            <div className="space-y-4 text-gray-700 leading-relaxed lg:col-span-6">
              <h1 className="text-sky-900 font-semibold text-xl md:text-2xl md:leading-tight font-heading">{impressumContent.title}</h1>

              {impressumContent.sections.map((section, index) => (
                <div key={index} className="mb-6">
                  <h2 className="font-extrabold text-lg text-gray-900 font-heading mb-1">
                    {section.title}
                  </h2>
                  {section.lines.map((line, idx) => (
                    <p key={idx} className="text-gray-700 text-base sm:text-lg">
                      {line}
                    </p>
                  ))}
                </div>
              ))}

              <p className="text-sm text-gray-500 mt-8 font-body">
                {impressumContent.lastUpdated}
              </p>
            </div>
            <div className="lg:col-span-4">
              <div className="relative w-full h-full rounded-xl group">
                <img
                  className="relative z-10 w-full h-full object-cover rounded-xl shadow-xl "
                  src="/Mitgliedschaft/1.webp"
                  alt="Angelfreunde 1866"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Impressum;
